export const aboutCPdata = [
    {
        icon: 'landing-uptodate-icon',
        desc: 'Stay up-to-date on all your incoming and outgoing CrossProm requests'
    },
    {
        icon: 'landing-automatically-icon',
        desc: 'Automatically track results in Google Analytics and Kickstarter dashboard'
    },
    {
        icon: 'landing-uplonce-icon',
        desc: "Upload your CrossProm info once, and we'll share it with all your partners"
    },
    {
        icon: 'landing-allpartns-icon',
        desc: "Get all your partners' update info from your dashboard"
    },
    {
        icon: 'landing-reatarget-icon',
        desc: 'Retarget your new Kickstarter page visitors with our FB pixel integration'
    },
    {
        icon: 'landing-negotiate-icon',
        desc: 'Negotiate new terms with your fellow campaigners with our native chat'
    }
]
export const communityData = [
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/raghav-testimonial.jpeg?alt=media&token=3089fa9b-495f-499b-9cba-13498ae9ec08',
        name: 'Raghav Agarwal',
        title: 'FIREUP Cookware',
        desc: "It was a pleasure working with the Crossprom team for our crowdfunding campaigns. We collaborated with like-minded campaign owners to effectively cross-promote each other's products and increase sales by reaching out to maximum potential customers. FIREUP Cookware Limited would recommend Crossprom to all business owners seeking an optimum platform to grow their business. Our team looks forward to leveraging Crossprom for our future campaigns."
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi1.png?alt=media&token=f1931f8d-19fb-4765-bb42-3ff8af8f8823',
        name: 'Hannan Khurshid Hakim',
        title: 'Skadu - Your Shortcut To A Hyper Clean Home',
        desc: "CrossProm has been an important tool for raising consistently during the mid-campaign period for us. We ran a cross-promotion with our friends at 'Pico' and that raised us USD 5,000/- I would highly recommend this as a strategy for all campaigns.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi2.png?alt=media&token=d825c4e5-e20d-423a-be10-0962041250f7',
        name: 'Boz Zou',
        title: 'UVMask: Complete Protection for the New Normal',
        desc: "CrossProm is an easy-to-use platform that greatly simplified the cross-promotion process for us so we can focus on growing our campaign. Thanks to it and the team’s support, we kept raising thousands of dollars per update as all 3 spots were easily filled every time.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi3.png?alt=media&token=3ee57422-73a0-4704-b5c2-9fff0f60debd',
        name: 'Sandy Stinson',
        title: 'PooPail: World’s only 2-in-1 solution for cleaning dog poop',
        desc: "CrossProm helped me bring a big new wave of backers to my campaign! They really made collaboration with other campaigners easy... I can't imagine how much time it would have taken me to contact each campaign individually.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fkiril.jpg?alt=media&token=7e29b221-373d-448f-9b76-200c4a81faef',
        name: 'Kirill Nesterov',
        title: 'Nest Brush: Self-dispensing Electric Toothbrush',
        desc: "For our crowdfunding campaign on Kickstarter we have actively used cross-promotion channel to get more targeted backers to our campaign. The conversion rate of this channel was almost 15% which is really high compared to other channels from where the rate was 2-4%. So this is a good channel and for sure it is worth using. As a creator I highly recommend it."
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/img%2Ftestimonial.png?alt=media&token=c32faf29-d4b0-469b-9649-1cc2b4a6eae7',
        name: '',
        title: 'Vitt, CTO',
        desc: "We were using Cross Promotion to get extra traffic from targeted crowdfunding campaigns. Backers who were interested in other similar (but not competitor products) and that might be interested also in ours. So this is a great traffic and high conversion source."
    }
]
export const creatorsData = [
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/raghav-testimonial.jpeg?alt=media&token=3089fa9b-495f-499b-9cba-13498ae9ec08',
        name: 'Raghav Agarwal',
        title: 'FIREUP Cookware',
        desc: "It was a pleasure working with the Crossprom team for our crowdfunding campaigns. We collaborated with like-minded campaign owners to effectively cross-promote each other's products and increase sales by reaching out to maximum potential customers. FIREUP Cookware Limited would recommend Crossprom to all business owners seeking an optimum platform to grow their business. Our team looks forward to leveraging Crossprom for our future campaigns."
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi1.png?alt=media&token=f1931f8d-19fb-4765-bb42-3ff8af8f8823',
        name: 'Hannan Khurshid Hakim',
        title: 'Skadu - Your Shortcut To A Hyper Clean Home',
        desc: "CrossProm has been an important tool for raising consistently during the mid-campaign period for us. We ran a cross-promotion with our friends at 'Pico' and that raised us USD 5,000/- I would highly recommend this as a strategy for all campaigns.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi2.png?alt=media&token=d825c4e5-e20d-423a-be10-0962041250f7',
        name: 'Boz Zou',
        title: 'UVMask: Complete Protection for the New Normal',
        desc: "CrossProm is an easy-to-use platform that greatly simplified the cross-promotion process for us so we can focus on growing our campaign. Thanks to it and the team’s support, we kept raising thousands of dollars per update as all 3 spots were easily filled every time.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi3.png?alt=media&token=3ee57422-73a0-4704-b5c2-9fff0f60debd',
        name: 'Sandy Stinson',
        title: 'PooPail: World’s only 2-in-1 solution for cleaning dog poop',
        desc: "CrossProm helped me bring a big new wave of backers to my campaign! They really made collaboration with other campaigners easy... I can't imagine how much time it would have taken me to contact each campaign individually.",
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fkiril.jpg?alt=media&token=7e29b221-373d-448f-9b76-200c4a81faef',
        name: 'Kirill Nesterov',
        title: 'Nest Brush: Self-dispensing Electric Toothbrush',
        desc: "For our crowdfunding campaign on Kickstarter we have actively used cross-promotion channel to get more targeted backers to our campaign. The conversion rate of this channel was almost 15% which is really high compared to other channels from where the rate was 2-4%. So this is a good channel and for sure it is worth using. As a creator I highly recommend it."
    },
    {
        photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/img%2Ftestimonial.png?alt=media&token=c32faf29-d4b0-469b-9649-1cc2b4a6eae7',
        name: '',
        title: 'Vitt, CTO',
        desc: "We were using Cross Promotion to get extra traffic from targeted crowdfunding campaigns. Backers who were interested in other similar (but not competitor products) and that might be interested also in ours. So this is a great traffic and high conversion source."
    }
]

export const convertingUpdatesData = [
    {
        step: 'Step 1: Explore',
        title: 'Find Crossprom-Friendly Campaigns',
        desc: "Browse through the CrossProm campaigns' database and discover the best matches by category and backers number.",
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/vid%2F01_Find_Crossprom_Friendly.mp4?alt=media&token=05cef14e-5726-4738-8438-953816052bb7'
    },
    {
        step: 'Step 2: Partner',
        title: 'Kickstart Successful Collaborations',
        desc: "Send and receive CrossProm requests from within the platform to start promoting each other.",
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/vid%2F02_Kickstart.mp4?alt=media&token=634aad6f-d55a-478e-b58e-b72823e8a045'
    },
    {
        step: 'Step 3: Schedule',
        title: 'Secure Your Page Traffic',
        desc: "Plan the exact dates and spots for promoting your campaign on other creators' updates.",
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/vid%2Fkssave.mp4?alt=media&token=3e117ada-41e2-412b-90e5-6189dfe2b8e4'
    },
    {
        step: 'Step 4: Post',
        title: 'Automatically post cross-promotions',
        desc: "Post cross-promotions into your Kickstarter update with a single button click.",
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/vid%2Fpost-video.mp4?alt=media&token=a0f9096a-c3c3-4fb1-82a2-1308097d72e0'
    },
    {
        step: 'Step 5: Analyze',
        title: 'Track Your Successes',
        desc: "Once the update is live, measure your new traffic growth and conversions from your partner campaigns' backers.",
        videoUrl: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/vid%2FGoogle_Analytics.mp4?alt=media&token=8d8d8333-7bcc-480f-a28f-fc07cb34a78b'
    }
]
export const conversionData = [
    {
        title: 'Grow Your Backer Community',
        desc: 'Market your campaign to interested audiences and effortlessly convert them into loyal backers.',
        icon: 'landing-community',
        bgColor: '#FFF7E0'
    },
    {
        title: 'Get up to 11% Conversion Rates',
        desc: "Team up with other creators to drive up traffic and effectively increase your campaign's conversion rates.",
        icon: 'landing-rates',
        bgColor: '#E6FAF4'
    },
    {
        title: 'Raise up to $50,000+ Funds',
        desc: "Single cross-promotion can fill your crowdfunding bank with an additional $6,000 ",
        icon: 'landing-funds',
        bgColor: '#F1F2FE'
    },
]
